import { useRef } from 'react'
import * as linkActions from 'store/ducks/lastLink/actions';
import * as authActions from 'store/ducks/auth/actions';
import LangList from 'components/LangList/LangList'
import Popup from 'components/Popup/Popup'
import CheckQueue from 'components/Popup/components/CheckQueue/CheckQueue'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'store/store'
import ScheduleQueue from 'components/ScheduleQueue/ScheduleQueue'
import { Button } from '@mui/material'
import Logo from 'assets/images/logo-svg.svg'
import LogoutIcon from '@mui/icons-material/Logout';
import { ReactComponent as ResetIcon} from 'assets/images/reset.svg';
import './SchedulePage.sass'

const SchedulePage: React.FC = () => {
  const ref = useRef<any>(null)
  const i18n = useSelector(
		(state: AppState) => state.i18n.data.pages.SchedulePage,
	);
  const dispatch = useDispatch();


  const signOut = () => {
    dispatch(linkActions.addNewLink());
    dispatch(authActions.signOut());
  };
  
  return (
    <div className="schedule-page">
      <LogoutIcon
        onClick={signOut}
        className='schedule-page__logout'
        sx={{ fontSize: 40, color: '#4ACBCE' }}
      />
        
      <ResetIcon   onClick={() => window.location.reload()} className='schedule-page__reset'/>
      <div className="schedule-page__logo-wrap">
        <img src={Logo} alt="" className="schedule-page__logo" />
        <div className="schedule-page__logo-name">IMTIHON<br />MARKAZI</div>
      </div>
      <ScheduleQueue/>

      <Button
        color='success'
        className='schedule-page__button'
        variant='contained'
        type='submit'
        size='large'
        fullWidth
        onClick={() => ref.current.onShow()}
      >
        {i18n.checkQueue}
      </Button>
      <LangList/>
      <Popup ref={ref} top>
        <CheckQueue closeHandler={() => ref.current.onHide()}/>
      </Popup>
    </div>

  )
}

export default SchedulePage